// config.js

const config = {
    // REACT_APP_API:'http://localhost:8081/api/v1',
    REACT_APP_API:'https://solesphere-gdi8.onrender.com/api/v1',
    // Add other configuration variables as needed
  };
  
  export default config;
  